import { Component, ElementRef, HostListener, EventEmitter, Input,
  Output, OnInit, ChangeDetectionStrategy, ViewChild, SimpleChanges, DoCheck } from '@angular/core';
import { Observable, Subject } from 'rxjs';

import { FormControl, FormGroup, FormArray, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { ActivatedRoute } from '@angular/router';
import { Router, NavigationExtras } from '@angular/router';

import { ProjectmanagementService } from '../../service/projectmanagement.service';

import { MyErrorHandler } from '../../errorhandler/errorhandler';

import { environment } from '../../../environments/environment';

import * as _ from 'underscore';

import * as languageConfig from '../../../../../../src/assets/i18n/configuration/configuration.json';

declare var jQuery;

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-ctl-project-form',
  templateUrl: './ctl.project.form.component.html',
  styleUrls: ['./ctl.project.form.component.css'],
  providers: [ProjectmanagementService]
})

export class CtlProjectForm implements OnInit, DoCheck {

  environment;

  @Input() myFormGroup: FormGroup;
  @Input() viewType: string;
  @Input() project_id: string;
  @Input() myCountryList: any[];
  @Input() myPartnerList: any[];
  @Input() myLeadPartner: any;
  @Input() myAdminList: any[];
  @Input() myLeadAdmin: any;
  @Input() data: any;

  // @Input() projectData;
  lPartnerList: any[];
  edited = true;
  @Input() myFileDetail: any[];

  @Output() myFormChange: EventEmitter<boolean> = new EventEmitter();
  @Output() enableArchive: EventEmitter<boolean> = new EventEmitter();
  @Output() openModal: EventEmitter<object> = new EventEmitter();
  @Output() evEditEnable: EventEmitter<boolean> = new EventEmitter();

  // parent to child event
  @Input() fromParent: Subject<any>;
  projectStatus: any;
  myPartnerListWithoutType = [];
  countrySelectConfig:any;
  partnerSelectConfig:any;
  myAdminSelectConfig:any;

  languageConfiguration: any;
  textDir:any;
  constructor(
    public translate: TranslateService,
    private _addnewprojectService: ProjectmanagementService,
    private router: Router,
    private el: ElementRef) {
      this.languageConfiguration = (languageConfig as any).default;
      translate.addLangs([this.languageConfiguration.languages]);
      translate.setDefaultLang(this.languageConfiguration.defaultLang);
      let selectedLang = sessionStorage.getItem('selectedLang');
      this.textDir =  sessionStorage.getItem('textDir');
      let langRegExp = new RegExp(this.languageConfiguration.languageRegexp);
      if(selectedLang){
        translate.use(selectedLang.match(langRegExp) ? selectedLang : this.languageConfiguration.defaultLang);  
      } else {
        const browserLang = translate.getBrowserLang();                  
        translate.use(browserLang.match(langRegExp) ? browserLang : this.languageConfiguration.defaultLang);  
      } 
    }
    adminListWithoutType = [];
    myAdminListWithoutType = [];

  ngOnInit() {
      // jQuery('[data-toggle="tooltip"]').tooltip();
      this.environment = environment;
      // this.myPartnerList
      this.translate.get('Select a country').subscribe((translated: string) => {
        this.countrySelectConfig = {
          placeholder: translated,
          displayKey: 'name',
          search: true,
          height: '150px',
          customComparator: ((a, b) => {
            const nameA = a.name.toUpperCase(); // ignore upper and lowercase
            const nameB = b.name.toUpperCase(); // ignore upper and lowercase
            if (nameA < nameB) {
              return -1;
            }
            if (nameA > nameB) {
              return 1;
            }
      
            // names must be equal
            return 0;
          })
          // limitTo: 5
        };
        this.partnerSelectConfig = {
          placeholder: this.translate.instant('Select a lead partner'),
          displayKey: 'name',
          search: true,
          height: '150px'
        };
        this.myAdminSelectConfig = {
          placeholder: this.translate.instant('Select a lead admin'),
          displayKey: 'name',
          search: true,
          height: '150px'
        };
      });
      this.myPartnerList.forEach(element => {
        this.myPartnerListWithoutType.push(element.partner);
      });
      this.myPartnerListWithoutType = this.myPartnerListWithoutType.slice();
      if (this.myAdminList){
        this.myAdminList.forEach(element => {
          element.admin.name = element.admin.first_name+' '+element.admin.last_name;
          this.myAdminListWithoutType.push(element.admin);
        });
        this.myAdminListWithoutType = this.myAdminListWithoutType.slice();
      }
      if (this.data && this.data.name) { } else {
        this.lPartnerList = this.myPartnerList.slice(0);
      }
  }

  ngDoCheck() {
    //  console.log("input chnaged");
      this.myPartnerList.forEach(element => {
        this.myPartnerListWithoutType.push(element.partner);
      });
      this.myPartnerListWithoutType = this.myPartnerListWithoutType.slice();

      // if (this.myPartnerList !== this.lPartnerList) {
      if (!_.isEqual(this.myPartnerList, this.lPartnerList)){
        this.lPartnerList = this.myPartnerList.slice(0);
        this.refreshSelect('partner');
      }
      if (this.myAdminList) {
        this.myAdminList.forEach(element => {
          element.admin.name = element.admin.first_name + ' ' + element.admin.last_name;
          this.myAdminListWithoutType.push(element.admin);
        });
        this.myAdminListWithoutType = this.myAdminListWithoutType.slice();
      }
  }

  edit() {
    this.evEditEnable.emit(true);
  }

  /* events - start */
  confirmEnableDisable(checkstatus) {
    if (this.data.active === true ){
      this.edited = false;
    } else{
      this.edited = true;
    }
    this.enableArchive.emit(checkstatus);
    // setTimeout(() => {
    //   this.edited = true;
    // }, 2);
  }

  formDataChanged() {
    this.myFormChange.emit(true);
  }
  /* events - end */

  openPartnerModal() {
    this.openModal.emit({});
  }

  removePhoto() {
    //
    if (this.data && this.data.logo) {
      // delete this.data.logo.url;
      this.myFormGroup.get('logo').patchValue({url: null});
      this.formDataChanged();
    }
    console.log('remove photo');
  }

  renderSelect(item) {
    if ( item === 'country') {
      // jQuery('#selectCountry').selectpicker('render');
    } else if (item === 'partner') {
      // jQuery('#selectPartner').selectpicker('render');
    } else if ( item === 'admin') {
      // jQuery('#selectAdmin').selectpicker('render');
    }
 }
 refreshSelect(item) {
   if ( item === 'country') {
    //  jQuery('#selectCountry').selectpicker('refresh');
   } else if(item === 'partner') {
    // jQuery('#selectPartner').selectpicker('refresh');
   } else if ( item === 'admin') {
    //  jQuery('#selectAdmin').selectpicker('refresh');
   }
 }

 onSelectChange(type, data) {
   console.log('on select change ' + data);
   // this.myFormGroup.get(type).patchValue(JSON.parse(data));
 }

 avoidWhiteSpace(event, field){
  if (this.myFormGroup.get(field).value === ' ' && this.myFormGroup.get(field).value.trim() === ''){
    const k = event ? event.which : event.keyCode;
    if (k === 32) { return false; }
  }else if (this.myFormGroup.get(field).value == null){
    const k = event ? event.which : event.keyCode;
    if (k === 32) { return false; }
  }
 }
  fixLogoUrl(url?) {
    if (url) {
    if (url.match('undefined')) {
      return url.replace('undefined', environment.msdpAPIBaseURL);
    } else if (url.match('FILEBASEURL')) {
      return url.replace('<FILEBASEURL>', environment.msdpAPIBaseURL);
    } else {
      return url;
    }
    }
    return 'assets/images/upload_image.png';
  }
}
